export function initAccordion() {
  const headers = document.querySelectorAll('.js-accordion-header');

  if (!headers.length) return;

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.js-accordion-item');
      const content = item.querySelector('.js-accordion-content');
      const icon = item.querySelector('.js-accordion-icon');
      const isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.js-accordion-item').forEach(otherItem => {
        if (otherItem !== item && otherItem.classList.contains('is-open')) {
          otherItem.classList.remove('is-open');
          const otherContent = otherItem.querySelector('.js-accordion-content');
          const otherIcon = otherItem.querySelector('.js-accordion-icon');
          const otherHeader = otherItem.querySelector('.js-accordion-header');
          
          if (otherContent) otherContent.style.maxHeight = null;
          if (otherIcon) otherIcon.textContent = '+';
          
          otherHeader.classList.remove('pb-[24px]', 'md:pb-[24px]');
          otherHeader.classList.add('pb-[28px]', 'md:pb-[32px]');
        }
      });


      if (!isOpen) {
        item.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + "px";
        if (icon) icon.textContent = '-';
        
        header.classList.remove('pb-[28px]', 'md:pb-[32px]');
        header.classList.add('pb-[24px]', 'md:pb-[24px]');

      } else {
        item.classList.remove('is-open');
        content.style.maxHeight = null;
        if (icon) icon.textContent = '+';
        
        header.classList.remove('pb-[24px]', 'md:pb-[24px]');
        header.classList.add('pb-[28px]', 'md:pb-[32px]');
      }
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.js-accordion-item.is-open .js-accordion-content').forEach(content => {
      content.style.maxHeight = content.scrollHeight + "px";
    });
  });
}